<div *ngIf="projectLoaded() && showSidebarButtons"
     class="button-top-group relative-container">
  <!--  when the page is too narrow for the text in the quick access save cancel buttons the text -->
  <!--  text is replaced with icons -->
  <button [type]="saveButtonType"
          [id]="idPrefix+'-side-save_button'"
          class="mat-mdc-button btn-green sidebar-buttons"
          [ngClass]="{'icon-buttons' : buttonIconsActive()}"
          mat-button
          [disabled]="!formValid || !canEditProject()"
          (click)="sidebarSaveClicked()">
    {{ (buttonIconsActive() ? '' : (saveButtonText | anessaTranslation: trigger)) }}
    <span class="material-icons"
          [ngStyle]="{'display': (buttonIconsActive() ? 'block' : 'none')}"
    >save</span>
  </button>
  <ng-container *ngIf="showSidebarSaveConfirm">
    <app-confirmation-pop-up
      [confirmMessage]="saveConfirmMessage"
      [confirmText]="saveConfirmText"
      [rejectText]="saveCancelText"
      (confirmed)="confirmSaveClicked()"
      (rejected)="rejectSaveClicked()"
      [positionLeft]="-230"
    ></app-confirmation-pop-up>
  </ng-container>
  <ng-container *ngIf="showCancel">
    <button type="button"
            [id]="idPrefix+'-side-cancel_button'"
            class="mat-mdc-button btn-red sidebar-buttons"
            [ngClass]="{'icon-buttons' : buttonIconsActive()}"
            mat-button
            (click)="sidebarCancelClicked()">
      {{ (buttonIconsActive() ? '' : (sidebarCancelText | anessaTranslation: trigger)) }}
      <span class="material-icons"
            [ngStyle]="{'display': (buttonIconsActive() ? 'block' : 'none')}"
      >clear</span>
    </button>
    <ng-container *ngIf="showSidebarCancelConfirm">
      <app-confirmation-pop-up
        [confirmMessage]="cancelConfirmMessage"
        [confirmText]="cancelConfirmText"
        [rejectText]="cancelRejectText"
        (confirmed)="confirmCancelClicked()"
        (rejected)="rejectCancelClicked()"
        [positionLeft]="-100"
      ></app-confirmation-pop-up>
    </ng-container>
  </ng-container>
</div>
<div *ngIf="showBottomButtons"
     [ngClass]="buttonGroupStyling"
     class="relative-container"
>
  <ng-container *ngIf="showSave">
    <button [type]="saveButtonType"
            [id]="idPrefix+'-bottom-save_button'"
            mat-button
            class="mat-mdc-button"
            [ngClass]=" [buttonStyling, enableUnsavedChangesBtn && !unsavedChanges ? 'btn-no-unsaved-changes' : 'btn-green']"
            [disabled]="!formValid || !canEditProject()"
            (click)="saveClicked()">{{ saveButtonText | anessaTranslation: trigger }}
    </button>
    <ng-container *ngIf="showSaveConfirmation">
      <app-confirmation-pop-up
        [confirmMessage]="saveConfirmMessage"
        [confirmText]="saveConfirmText"
        [rejectText]="saveCancelText"
        (confirmed)="confirmSaveClicked()"
        (rejected)="rejectSaveClicked()"
        [positionBottom]="-30"
        [positionLeft]="300"
      ></app-confirmation-pop-up>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="showCancel">
    <button type="button"
            [id]="idPrefix+'-bottom-cancel_button'"
            mat-button
            class="mat-mdc-button btn-red"
            [ngClass]="buttonStyling"
            (click)="cancelClicked()">{{ cancelButtonText | anessaTranslation: trigger }}
    </button>
    <ng-container *ngIf="showCancelConfirmation">
      <app-confirmation-pop-up
        [confirmMessage]="cancelConfirmMessage"
        [confirmText]="cancelConfirmText"
        [rejectText]="cancelRejectText"
        (confirmed)="confirmCancelClicked()"
        (rejected)="rejectCancelClicked()"
        [positionBottom]="-30"
        [positionLeft]="300"
      ></app-confirmation-pop-up>
    </ng-container>
  </ng-container>
</div>
